// extracted by mini-css-extract-plugin
export default {"social":"cMJTxwRj","mobile":"ZwHSqiO2","comments":"EYxFdhcQ","commentsTitle":"FwG_ETgo","commentsCount":"OtknXk3O","rambler-share":"rambler-share"};